
class Customreviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      var swiper = new Swiper(
        ".image-slider--" + this.getAttribute("data-sectionid"),
        {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1,
          allowTouchMove: false,
          navigation: false,
          touchStartPreventDefault: false,
          passiveListeners: false,
          autoplay: false,
          freeMode: true,
          effect: "fade",
          watchSlidesProgress: true,
        }
      );
      var swiper2 = new Swiper(
        ".content-slider--" + this.getAttribute("data-sectionid"),
        {
          loop: true,
          spaceBetween: 10,
          allowTouchMove: false,
          navigation: false,
          autoplay: false,
          effect: "fade",
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: swiper,
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-reviews", Customreviews);

class Collectionslidernew extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".collection-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.2,
          spaceBetween: 10,
          grabCursor: true,
          touchStartPreventDefault: false,
          passiveListeners: false,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            900: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
          },
        }
      );

        let lastIsDesktop = window.innerWidth >= 769;
        let sliderHandlers = [];
        
        function initSliderScript() {
          // Clear existing slider behavior
          sliderHandlers.forEach(({ slider, enter, leave }) => {
            slider.removeEventListener('mouseenter', enter);
            slider.removeEventListener('mouseleave', leave);
          });
          sliderHandlers = [];
        
          // Re-initialize only for desktop
          if (window.innerWidth >= 769) {
            document.querySelectorAll('.custom-hover-slider').forEach(slider => {
              const slides = slider.querySelectorAll('.custom-slide');
              const fill = slider.querySelector('.custom-progress-fill');
              const delay = parseInt(slider.getAttribute('data-delay')) || 2000;
              const totalTime = slides.length * delay;
        
              let index = 0;
              let interval = null;
        
              const showSlide = (i) => {
                slides.forEach((slide, idx) => {
                  slide.classList.toggle('active', idx === i);
                });
              };
        
              const startProgressBar = () => {
                fill.style.transition = 'none';
                fill.style.width = '0%';
                void fill.offsetWidth;
                fill.style.transition = `width ${totalTime}ms linear`;
                fill.style.width = '100%';
              };
        
              const startSlideshow = () => {
                index = 0;
                showSlide(index);
                startProgressBar();
                interval = setInterval(() => {
                  index++;
                  if (index >= slides.length) {
                    stopSlideshow();
                    startSlideshow();
                    return;
                  }
                  showSlide(index);
                }, delay);
              };
        
              const stopSlideshow = () => {
                clearInterval(interval);
                fill.style.transition = 'none';
                fill.style.width = '0%';
                index = 0;
                showSlide(index);
              };
        
              const enter = startSlideshow;
              const leave = stopSlideshow;
        
              slider.addEventListener('mouseenter', enter);
              slider.addEventListener('mouseleave', leave);
        
              sliderHandlers.push({ slider, enter, leave });
            });
          }
        }
        
        // Initial run
        initSliderScript();
        
        // Watch for breakpoint crossing
        window.addEventListener('resize', () => {
          const isDesktop = window.innerWidth >= 769;
          if (isDesktop !== lastIsDesktop) {
            lastIsDesktop = isDesktop;
            initSliderScript(); // re-run script logic only
          }
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("collection-slider-new", Collectionslidernew);

class Mediawithproductslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.style.opacity = "1";

      const sectionId = this.getAttribute("data-sectionid");

      var swiper = new Swiper(".product-grid-slider--" + sectionId, {
        slidesPerView: 1.2,
        spaceBetween: 0,
        touchStartPreventDefault: false,
        passiveListeners: false,
        freeMode: true,
        breakpoints: {
          580: {
            slidesPerView: 2.15,
            spaceBetween: 0,
          },
        },
      });
      const slideshow = this.querySelector(".slideshow--" + sectionId);
      const slides = slideshow.querySelectorAll(".slideshow__slide");
      const nextBtn = this.querySelector(".right-button--" + sectionId);
      const prevBtn = this.querySelector(".left-button--" + sectionId);
      let current = 0;

      function updateSlides() {
        slides.forEach((slide) => slide.classList.remove("is-active"));
        slides[current].classList.add("is-active");
      }

      nextBtn?.addEventListener("click", () => {
        current = (current + 1) % slides.length;
        updateSlides();
      });

      prevBtn?.addEventListener("click", () => {
        current = (current - 1 + slides.length) % slides.length;
        updateSlides();
      });

      updateSlides();
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("media-with-product-slider", Mediawithproductslider);

class Bannernew extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Pause and reset all videos in the slider section
    const pauseAllVideos = () => {
      const sectionId = this.getAttribute("data-sectionid");
      const selector = `.media-slider--${sectionId}`;
      document.querySelectorAll(`${selector} video`).forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });
    };

    // Play the active slide's video
    const playActiveSlideVideo = () => {
      const sectionId = this.getAttribute("data-sectionid");
      const selector = `.media-slider--${sectionId}`;
      // const activeVideo = document.querySelector(
      //   `${selector} .swiper-slide-active video`
      // );
      // if (activeVideo) {
      //   activeVideo.currentTime = 0;
      //   activeVideo.play();
      // }
      const desktopVideo = document.querySelector(
        `${selector} .swiper-slide-active video.main-video`
      );
      if (desktopVideo) {
        desktopVideo.currentTime = 0;
        desktopVideo.play();
      }
      const mobileVideo = document.querySelector(
        `${selector} .swiper-slide-active video.mobile-view`
      );
      if (mobileVideo) {
        mobileVideo.currentTime = 0;
        mobileVideo.play();
      }
    };

    // Initialize the Swiper instance
    const initializeSwiper = () => {
      const sectionId = this.getAttribute("data-sectionid");
      const selector = `.media-slider--${sectionId}`;
      const time = Number($(this).data("time")) || 6000; // Default to 6000ms
      const autoplayData = $(this).data("autoplay");
      const autoplayEnabled = autoplayData === "false" ? false : true; // Respect data-autoplay attribute

      const swiper = new Swiper(selector, {
        spaceBetween: 15,
        slidesPerView: 1,
        touchStartPreventDefault: false,
        passiveListeners: false,
        speed: 400,
        // effect: "slide",
        effect: "fade",
        loop: true,
        mousewheel: {
          forceToAxis: true,
        },
        autoplay: autoplayEnabled
          ? {
              delay: time,
              disableOnInteraction: false,
            }
          : false,
        pagination: {
          el: `.swiper-pagination--${sectionId}`,
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          769: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
        on: {
          touchMove: () => {
            const sectionId = this.getAttribute("data-sectionid");
            const selector = `.media-slider--${sectionId}`;
            const autoplay = this.swiperInstance.autoplay.running;

            // Stop autoplay when a bullet is clicked
            this.setAttribute("data-autoplay", false);

            // this.swiperInstance.autoplay.stop();

            // Update the play button if needed
            const playButton = document.querySelector(
              `.play-button--${sectionId}`
            );

            playButton.classList.remove("active", "restart");
            playButton.classList.add("pause");

            // // Remove active class from the pagination bullet
            // const activeBullet = document.querySelector(
            //   `${selector} .swiper-pagination-bullet-active`
            // );
            // activeBullet.classList.remove("active");
            // activeBullet.classList.add("noactive");

            playActiveSlideVideo();
          },
          init: () => {

             
            // Ensure swiperInstance is initialized
            const delay = 100; // Delay in milliseconds

            setInterval(() => {
              $(`${selector} .swiper-slide`).each(function () {
                const slide = $(this);

                if (slide.hasClass("swiper-slide-active")) {
                  setTimeout(() => {
                    slide.addClass("active");
                  }, delay);
                } else {
                  setTimeout(() => {
                    slide.removeClass("active");
                  }, delay);
                }
              });
            }, 200);
            const paginationBullets = document.querySelectorAll(
              ".swiper-pagination-bullet"
            );
            if (paginationBullets.length > 0) {
              console.log(paginationBullets.length + "    dddddd");
              paginationBullets.forEach((bullet) => {
                bullet.addEventListener("click", () => {
                  const sectionId = this.getAttribute("data-sectionid");
                  const selector = `.media-slider--${sectionId}`;
                  const autoplay = this.swiperInstance.autoplay.running;

                  // Stop autoplay when a bullet is clicked
                  // this.setAttribute("data-autoplay", false);

                  // this.swiperInstance.autoplay.stop();

                  // Update the play button if needed
                  const playButton = document.querySelector(
                    `.play-button--${sectionId}`
                  );

                  playButton.classList.remove("active", "restart");
                  playButton.classList.add("pause");

                  // Remove active class from the pagination bullet
                  const activeBullet = document.querySelector(
                    `${selector} .swiper-pagination-bullet-active`
                  );
                  activeBullet.classList.remove("active");
                  activeBullet.classList.add("noactive");

                  playActiveSlideVideo();
                });
              });
            }

            const bullets = document.querySelectorAll(
              ".swiper-pagination-bullet"
            );
            bullets.forEach((bullet) => {
              // const svg = `
              // <svg width="20px" height="20px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="thb-pagination-svg" preserveAspectRatio="none">
              //   <circle cx="10" cy="10" r="9" stroke="var(--color-text, #fff)" stroke-width="6"></circle>
              // </svg>`;
              const svg = `
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" class="thb-pagination-svg"  width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13"></circle><circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: ${time}ms"></circle></svg>`;
              bullet.innerHTML = svg; // Add the SVG inside the bullet
            });

            const sectionplayId = this.getAttribute("data-sectionid");

            const playButton = document.querySelector(
              `.play-button--${sectionplayId}`
            );

            if (playButton) {
              playButton.addEventListener("click", () => {
                const sectionId = this.getAttribute("data-sectionid");
                const selector = `.media-slider--${sectionId}`;
                const autoplay = this.swiperInstance.autoplay.running;

                if (autoplay) {
                  // Stop autoplay and update play button classes when autoplay is running
                  // this.setAttribute("data-autoplay", false);
                  // this.swiperInstance.autoplay.stop();
                  playButton.classList.add("pause");
                  playButton.classList.remove("active");

                  // Remove the `active` class from the pagination bullet
                  const activeBullet = document.querySelector(
                    selector + " .swiper-pagination-bullet-active"
                  );
                  if (activeBullet) {
                    activeBullet.classList.remove("active");
                    activeBullet.classList.add("noactive");
                  }
                } else {
                  if (autoplay == false) {
                    // this.setAttribute("data-autoplay", true);
                  }
                  // Remove the `active` class from the pagination bullet
                  const activeBullet = document.querySelector(
                    selector + " .swiper-pagination-bullet-active"
                  );
                  if (activeBullet) {
                    activeBullet.classList.remove("noactive");
                    activeBullet.classList.add("active");
                  }
                  // If 'restart' class is added, restart autoplay and go to the first slide
                  if (playButton.classList.contains("restart")) {
                    playButton.classList.remove("restart");
                    playButton.classList.add("active");
                    this.swiperInstance.autoplay.start();
                    this.swiperInstance.slideTo(0); // Go to the first slide
                  } else {
                    playButton.classList.add("active");
                    playButton.classList.remove("pause");
                    this.swiperInstance.params.autoplay.delay =
                      Number($(this).data("time")) || 6000;
                    this.swiperInstance.autoplay.start();
                  }
                }
              });
            }
          },
          slideChangeTransitionEnd: () => {
            pauseAllVideos();
            playActiveSlideVideo();

            // Ensure pagination is updated and add active class
            swiper.pagination.update();
            const allBullets = document.querySelectorAll(
              selector + " .swiper-pagination-bullet"
            );
            allBullets.forEach((bullet) => bullet.classList.remove("active"));
            const activeBullet = document.querySelector(
              selector + " .swiper-pagination-bullet-active"
            );
            if (activeBullet) {
              activeBullet.classList.remove("noactive");
              activeBullet.classList.add("active");
            }

            // Stop autoplay when the last slide is reached and change button to 'restart'
            // if (swiper.isEnd) {
            //   swiper.autoplay.stop();
            //   const playButton = document.querySelector(".play-button");
            //   setTimeout(() => {
            //     if (playButton) {
            //       playButton.classList.add("restart");
            //       playButton.classList.remove("active", "pause");
            //     }
            //   }, time);
            // }
          },
          autoplay: () => {
            // Update active bullet during autoplay
            swiper.pagination.update();
            const activeBullet = document.querySelector(
              selector + " .swiper-pagination-bullet-active"
            );
            if (activeBullet) {
              activeBullet.classList.remove("noactive");
              activeBullet.classList.add("active");
            }
          },
        },
      });

      return swiper; // Return the Swiper instance for further control
    };

    // Intersection Observer to handle visibility-based actions
    const handleIntersection = (entries, observer) => {
      const isVisible = entries[0].isIntersecting;
      const sectionId = this.getAttribute("data-sectionid");
      const selector = `.media-slider--${sectionId}`;

      if (isVisible) {
        $(this).css({ opacity: "1" });
        if (!this.swiperInstance) {
          this.swiperInstance = initializeSwiper();
        } else if (
          this.swiperInstance.autoplay &&
          this.swiperInstance.params.autoplay
        ) {
          this.swiperInstance.autoplay.start(); // Restart autoplay when visible
        }
        playActiveSlideVideo(); // Play the active video

        // Add active class to the bullet when section is visible
        const activeBullet = document.querySelector(
          `${selector} .swiper-pagination-bullet-active`
        );
        if (activeBullet) {
          activeBullet.classList.remove("noactive");
          activeBullet.classList.add("active");
        }
      } else {
        pauseAllVideos(); // Pause all videos
        if (this.swiperInstance && this.swiperInstance.autoplay) {
          // this.swiperInstance.autoplay.stop(); // Stop autoplay when not visible
        }

        // Remove active class when section is not visible
        const activeBullet = document.querySelector(
          `${selector} .swiper-pagination-bullet-active`
        );
        if (activeBullet) {
          activeBullet.classList.remove("active");
          activeBullet.classList.add("noactive");
        }
      }
    };

    const observer = new IntersectionObserver(handleIntersection.bind(this), {
      root: null, // Viewport as the root
      rootMargin: "0px 0px 400px 0px", // Trigger when 400px of the section enters
      threshold: 0.2, // Trigger when 20% of the section is visible
    });

    observer.observe(this);
  }
}

customElements.define("banner-new", Bannernew);

class Collectionsliderfeature extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".collection-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.2,
          spaceBetween: 10,
          grabCursor: true,
          freeMode: true,
          touchStartPreventDefault: false,
          passiveListeners: false,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            900: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("collection-slider-feature", Collectionsliderfeature);

class CustomContentwithImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var speed = $(this).attr('data-speed');
   
      var swiper = new Swiper(
        ".image-slider--" + this.getAttribute("data-sectionid"),
        {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1,
          allowTouchMove: false,
          navigation: false,
          touchStartPreventDefault: false,
          passiveListeners: false,
          autoplay: {
            delay: speed,
            disableOnInteraction: false,
          },
          effect: "fade",
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-content-with-image", CustomContentwithImage);


// const revealElements = document.querySelectorAll('.reveal-text');

// const observer = new IntersectionObserver((entries, observer) => {
//   entries.forEach(entry => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add('visible');
//       observer.unobserve(entry.target); // Remove if you only want it once
//     }
//   });
// }, {
//   threshold: 0.3, // Adjust if needed
//   rootMargin: '0px 0px 0% 0px' // triggers when 90% into view
// });

// revealElements.forEach(el => observer.observe(el));










class Articlecategoryslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".article-category-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.2,
          spaceBetween: 10,
          grabCursor: true,
          freeMode: true,
          touchStartPreventDefault: false,
          passiveListeners: false,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            900: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 0,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("article-category-slider", Articlecategoryslider);



class ArticleBanner extends HTMLElement {
  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const selector = `.media-slider--${sectionId}`;
    const timeMs = Number(this.getAttribute("data-time")) || 6000;
    const autoplayEnabled = String(this.getAttribute("data-autoplay")) !== "false";

    const pauseAllVideos = () => {
      document.querySelectorAll(`${selector} video`).forEach((v) => {
        try { v.pause(); v.currentTime = 0; } catch (e) {}
      });
    };

    const playActiveSlideVideo = () => {
      const activeSlide = document.querySelector(`${selector} .swiper-slide-active`);
      if (!activeSlide) return;

      const desktopVideo = activeSlide.querySelector("video.main-video");
      if (desktopVideo) { try { desktopVideo.currentTime = 0; desktopVideo.play(); } catch (e) {} }

      const mobileVideo = activeSlide.querySelector("video.mobile-view");
      if (mobileVideo) { try { mobileVideo.currentTime = 0; mobileVideo.play(); } catch (e) {} }
    };

    // CSS expects: .swiper-pagination-bullet-active.active
    const syncBulletClasses = () => {
      const bullets = document.querySelectorAll(`${selector} .swiper-pagination-bullet`);
      bullets.forEach((b) => b.classList.remove("active", "noactive"));

      const active = document.querySelector(`${selector} .swiper-pagination-bullet-active`);
      if (active) active.classList.add("active");
    };

    const initPaginationSvg = () => {
      document.querySelectorAll(`${selector} .swiper-pagination-bullet`).forEach((b) => {
        b.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" class="thb-pagination-svg" width="30" height="30" viewBox="0 0 30 30" xml:space="preserve">
            <circle class="circle-one" cx="15" cy="15" r="13"></circle>
            <circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration:${timeMs}ms"></circle>
          </svg>
        `;
      });
    };

    const startSwiper = () => {
      this.swiperInstance = new Swiper(selector, {
        spaceBetween: 15,
        slidesPerView: 1,
        touchStartPreventDefault: false,
        passiveListeners: false,
        speed: 400,
        effect: "fade",
        loop: true,
        mousewheel: { forceToAxis: true },
        autoplay: autoplayEnabled ? { delay: timeMs, disableOnInteraction: false } : false,
        pagination: { el: `.swiper-pagination--${sectionId}`, clickable: true },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 769: { slidesPerView: 1, spaceBetween: 20 } },
        on: {
          init: () => {
            initPaginationSvg();
            syncBulletClasses();
            playActiveSlideVideo();

            // bullet click pe bhi class sync (CSS animation trigger)
            document.addEventListener("click", (e) => {
              if (!e.target.closest(`${selector} .swiper-pagination-bullet`)) return;
              setTimeout(() => {
                syncBulletClasses();
                playActiveSlideVideo();
              }, 0);
            });
          },
          slideChangeTransitionStart: () => {
            // transition start pe reset feel ke liye
            syncBulletClasses();
          },
          slideChangeTransitionEnd: () => {
            pauseAllVideos();
            playActiveSlideVideo();

            // IMPORTANT: yahi pe .active lagti rahegi, tabhi CSS animation chalegi
            this.swiperInstance.pagination.update();
            syncBulletClasses();
          },
          autoplay: () => {
            // some builds fire this; keep safe
            syncBulletClasses();
          },
        },
      });

      // force initial
      setTimeout(syncBulletClasses, 0);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries[0].isIntersecting;

        if (visible) {
          this.style.opacity = "1";
          if (!this.swiperInstance) startSwiper();
          else if (this.swiperInstance.autoplay && autoplayEnabled) this.swiperInstance.autoplay.start();

          syncBulletClasses();
          playActiveSlideVideo();
        } else {
          pauseAllVideos();
          syncBulletClasses();
        }
      },
      { root: null, rootMargin: "0px 0px 400px 0px", threshold: 0.2 }
    );

    observer.observe(this);
  }
}

customElements.define("article-banner", ArticleBanner);


 
class Testimonialslider extends HTMLElement {
  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const selector = `.testimonial-slider--${sectionId}`;
    const timeMs = Number(this.getAttribute("data-time")) || 6000;
    const autoplayEnabled = String(this.getAttribute("data-autoplay")) !== "false";

    const pauseAllVideos = () => {
      document.querySelectorAll(`${selector} video`).forEach((v) => {
        try { v.pause(); v.currentTime = 0; } catch (e) {}
      });
    };

    const playActiveSlideVideo = () => {
      const activeSlide = document.querySelector(`${selector} .swiper-slide-active`);
      if (!activeSlide) return;

      const desktopVideo = activeSlide.querySelector("video.main-video");
      if (desktopVideo) { try { desktopVideo.currentTime = 0; desktopVideo.play(); } catch (e) {} }

      const mobileVideo = activeSlide.querySelector("video.mobile-view");
      if (mobileVideo) { try { mobileVideo.currentTime = 0; mobileVideo.play(); } catch (e) {} }
    };

    // CSS expects: .swiper-pagination-bullet-active.active
    const syncBulletClasses = () => {
      const bullets = document.querySelectorAll(`${selector} .swiper-pagination-bullet`);
      bullets.forEach((b) => b.classList.remove("active", "noactive"));

      const active = document.querySelector(`${selector} .swiper-pagination-bullet-active`);
      if (active) active.classList.add("active");
    };

    const initPaginationSvg = () => {
      document.querySelectorAll(`${selector} .swiper-pagination-bullet`).forEach((b) => {
        b.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" class="thb-pagination-svg" width="30" height="30" viewBox="0 0 30 30" xml:space="preserve">
            <circle class="circle-one" cx="15" cy="15" r="13"></circle>
            <circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration:${timeMs}ms"></circle>
          </svg>
        `;
      });
    };

    const startSwiper = () => {
      this.swiperInstance = new Swiper(selector, {
        spaceBetween: 15,
        slidesPerView: 1,
        touchStartPreventDefault: false,
        passiveListeners: false,
        speed: 400,
        effect: "fade",
        loop: true, 
        mousewheel: { forceToAxis: true },
        autoplay: autoplayEnabled ? { delay: timeMs, disableOnInteraction: false } : false,
        pagination: { el: `.swiper-pagination--${sectionId}`, clickable: true },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 769: { slidesPerView: 1, spaceBetween: 20 } },
        on: {
          init: () => {
            initPaginationSvg();
            syncBulletClasses();
            playActiveSlideVideo();

            // bullet click pe bhi class sync (CSS animation trigger)
            document.addEventListener("click", (e) => {
              if (!e.target.closest(`${selector} .swiper-pagination-bullet`)) return;
              setTimeout(() => {
                syncBulletClasses();
                playActiveSlideVideo();
              }, 0);
            });
          },
          slideChangeTransitionStart: () => { 
            syncBulletClasses();
          },
          slideChangeTransitionEnd: () => {
            pauseAllVideos();
            playActiveSlideVideo();
 
            this.swiperInstance.pagination.update();
            syncBulletClasses();
          },
          autoplay: () => { 
            syncBulletClasses();
          },
        },
      });

      // force initial
      setTimeout(syncBulletClasses, 0);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries[0].isIntersecting;

        if (visible) {
          this.style.opacity = "1";
          if (!this.swiperInstance) startSwiper();
          else if (this.swiperInstance.autoplay && autoplayEnabled) this.swiperInstance.autoplay.start();

          syncBulletClasses();
          playActiveSlideVideo();
        } else {
          pauseAllVideos();
          syncBulletClasses();
        }
      },
      { root: null, rootMargin: "0px 0px 400px 0px", threshold: 0.2 }
    );

    observer.observe(this);
  }
}

customElements.define("testimonial-section", Testimonialslider);
